import { AuthBridgeBase } from "./AuthBridgeBase";
import { AccountConfigToAuthDirectBridge } from "./AuthDirectBridge";
import { AccountConfigToAuthNativeBridge } from "./AuthNativeBridge";

export class AuthBridgeFactory {
	static getBridge = (): AuthBridgeBase => {
		return window.authBridgeNative
			? AccountConfigToAuthNativeBridge.Instance
			: AccountConfigToAuthDirectBridge.Instance;
	};
}
